export let idK1UserCol = {
	resizable: false,
	editable: false,
	headerName: "Je v K1",
	field: "",
	width: 50,
	cellRenderer: k1UserIdCellRenderer,
}

export function k1UserIdCellRenderer(params) {
	if (params.data.id_k1_user != null) {
		return "<i class='fas fa-user'></i>";
	} else {
		return "";
	}
}
